import { generateRandomUUID } from '../utils/random-uuid.js';
export const THERAME_EVENT_EXCHANGE = 'therame_events_exchange';
export const ALL_THERAME_EVENT_TYPES = [
    'office-user.handover',
    'office-user.created',
    'office-user.onboarded',
    'office-user.updated',
    'office-user.deleted',
    'office-product.created',
    'office-product.updated',
    'office-user.subscription-updated',
    'user.profile-image-updated',
    'user.stats-updated',
    'patient.created',
    'patient.onboarded',
    'patient.updated',
    'patient.deleted',
    'patient.handover',
    'patient.profile-completed',
    'patient.onboarding-tour-watched',
    'office.created',
    'office.updated',
    'office.main-admin-updated',
    'office.deleted',
    'office-location.created',
    'office-location.updated',
    'office-location.subscription-updated',
    'office-location.stats-updated',
    'office-location.deleted',
    'exercise.created',
    'exercise.deleted',
    'exercise-program.created',
    'exercise-program.updated',
    'exercise-program.deleted',
    'exercise-program.expired',
    'exercise-program.daily-reminder',
    'exercise-template.created',
    'exercise-template.updated',
    'exercise-template.deleted',
    'training-session.created',
    'training-session.started',
    'training-session.completed',
    'training-session.updated',
    'training-session.completion-reminder',
    'video-call.created',
    'video-call.started',
    'video-call.handover',
    'video-call.invite-status-change',
    'video-call.canceled',
    'video-call.ended',
    'video-call.patient-joined',
    'video-call.patient-invited',
    'office-location.branding-updated',
    'office-location.billing-details-updated',
    'office-location.numbering-updated',
    'office-location.mahnwesen-updated',
    'office-location.cancellation-fee-policy-updated',
    'office-location.absender-ik-updated',
    'office-location.datev-schnittstelle-updated',
    'office-location.datev-kontenrahmen-steuerart-updated',
    'office-location.datev-konten-mapping-updated',
    'office-location.datev-gewinnermittlungsart-switched',
    'office-location.datev-settings-updated-by-steuerberater',
    'steuerberater-token.minted',
    'steuerberater-token.revoked',
    'video-call.beginning-reminder',
    'custom-form-answer.created',
    'office-product-assignment.warning',
    'office-product-assignment.created',
    'invoice.created',
    'app-feedback.created',
    'diagnosis.created',
    'office-location.payed-feature-updated',
    'connected-stripe-account.payout-failed',
    'user.session-ended',
    'account.deleted',
    'question-answer.created',
    'office-user.association-sync',
    'treatment-plan.created',
    'treatment-plan.updated',
    'treatment-plan.deleted',
    'treatment-plan.activated',
    'treatment-plan.closed',
    'treatment-unit.cancelled',
    'treatment-unit.forfeited',
    'cancellation-fee.owed',
    'appointment.created',
    'appointment.patient-invited',
    'appointment.participant-status-changed',
    'appointment.participant-withdrew',
    'appointment.cancelled',
    'appointment.confirmed',
    'appointment.booking-confirmed',
    'appointment.booking-declined',
    'appointment.booking-auto-cancelled',
    'embed-booking.verification-requested',
    'appointment.rescheduled',
    'appointment.associated-with-plan',
    'appointment.dissociated-from-plan',
    'appointment.plan-link-set',
    'appointment-series.created',
    'appointment-series.updated',
    'appointment-series.cancelled',
    'appointment-series.split',
    'appointment-series.occurrence-materialized',
    'patient-invoice.draft-created',
    'patient-invoice.draft-deleted',
    'patient-invoice.issued',
    'patient-invoice.sent',
    'patient-invoice.paid',
    'patient-invoice.cancelled',
    'patient-invoice.dunning-blocked',
    'patient-invoice.dunning-block-lifted',
    'challenge.task-state-changed',
];
export const OFFICE_THERAME_EVENT_TYPES = [
    'office-user.created',
    'office-user.onboarded',
    'office-user.updated',
    'office-user.deleted',
    'user.profile-image-updated',
    'patient.created',
    'patient.onboarded',
    'patient.updated',
    'patient.deleted',
    'office.created',
    'office.updated',
    'office.main-admin-updated',
    'office.deleted',
    'office-location.created',
    'office-location.updated',
    'office-location.subscription-updated',
    'office-location.stats-updated',
    'office-location.deleted',
    'exercise.created',
    'exercise.deleted',
    'exercise-program.created',
    'exercise-program.updated',
    'exercise-program.deleted',
    'exercise-program.expired',
    'exercise-program.daily-reminder',
    'exercise-template.created',
    'exercise-template.updated',
    'exercise-template.deleted',
    'video-call.created',
    'video-call.handover',
    // Accept/decline activity is now the canonical, universal
    // `appointment.participant-status-changed` (fires for every appointment,
    // video or in-person). The video-only `video-call.invite-status-change` is
    // retained solely as a TAN-scheduling side-effect, so it is intentionally
    // NOT counted here — counting both would double-count video appointments.
    'appointment.participant-status-changed',
    'appointment.participant-withdrew',
    'video-call.canceled',
    'video-call.ended',
    'video-call.patient-joined',
    'office-location.branding-updated',
    'office-location.billing-details-updated',
];
export const PATIENT_THERAME_EVENT_TYPES = [
    'training-session.created',
    'training-session.started',
    'video-call.started',
    'custom-form-answer.created',
];
export class TherameEventDto {
    id;
    type;
    data;
    authContext;
    eventVersion;
    createdAt;
}
export const createTherameEvent = (type, data, authContext) => ({
    id: generateRandomUUID(),
    type,
    data,
    authContext,
    eventVersion: process.env.npm_package_version ?? 'UNKNOWN',
    createdAt: new Date(),
});
//# sourceMappingURL=event.base.js.map